const specs = {
  width: 620,
  title: {
    update: 'pages.equipment.modal.update.single.title',
    create: 'pages.equipment.modal.create.single.title'
  },
  okText: {
    update: 'pages.equipment.modal.update.single.okText',
    create: 'pages.equipment.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.equipment.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.equipment.fields.name.title',
        required: 'pages.equipment.fields.name.requiredMessage',
        placeholder: 'pages.equipment.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
